import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { filter, first, tap } from 'rxjs/operators';
import { LoadAccessContext } from './state/role.action';
import { RoleState } from './state/role.state';

@Injectable()
export class AccessContextsResolver {
  accessContextLoaded$: Observable<boolean> = this.store.select(RoleState.accessContextLoaded);

  constructor(private store: Store) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
    return this.accessContextLoaded$.pipe(
      tap((accessContextLoaded) => {
        if (!accessContextLoaded) {
          this.store.dispatch(new LoadAccessContext());
        }
      }),
      filter((accessContextLoaded) => accessContextLoaded),
      first()
    );
  }
}
